import { Component, OnInit, ViewChild } from '@angular/core';
import { AcLayerComponent, AcNotification, ActionType } from 'angular-cesium';
import { from, Observable } from 'rxjs';
import { DownloadComponent } from 'src/app/shared/components/download/download.component';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { DownloadService } from 'src/app/shared/services/download.service';
import { GlobeService } from 'src/app/shared/services/globe.service';

@Component({
    selector: 'app-point-info-provider',
    templateUrl: './point-info-provider.component.html',
    styleUrls: ['./point-info-provider.component.scss'],
})
export class PointInfoProviderComponent implements OnInit {
    @ViewChild(AcLayerComponent) layer: AcLayerComponent;
    htmls$: Observable<AcNotification>;

    filterOptions = {
        spatial: true,
        filterValues: {},
        sampleId: 1,
        GeoTypeId: 1,
        //GeoSpatialString: '',
    };

    htmlObj = {
        id: '0',
        actionType: ActionType.ADD_UPDATE,
        entity: {
            id: '0',
            show: false,
            name: 'Placeholder',
            position: Cesium.Cartesian3.fromDegrees(30, 30),
            sampleTypeId: 0,
            data: {
                latitude: 0,
                longitude: 0,
                samplingDepth: '',
                samplingYear: '',
                nuclides: [''],
                bioGroup: [''],
                numberOfTaxons: 0,
                numberOfDatasets: 0,
                numberOfSamples: 0,
                numberOfMeasures: 0,
                geometryInfo: {
                    positions: [],
                    polygonStr: '',
                },
                showDialog: false,
            },
            activeComponent: null,
        },
    };

    showPopup = false;

    constructor(
        private globeService: GlobeService,
        private dialogService: DialogService,
        private downloadService: DownloadService
    ) {
        // var entity = new Cesium.Entity({id: "sample-detail", name: "sample-detail"});
        // entity.addProperty("html");
        // var htmlProp = {
        //   id: 0,
        //   latitudeLongitude: [""],
        //   samplingYear: "",
        //   nuclides: [""],
        //   numberOfSamples: 0,
        //   numberOfMeasures: 0,
        //   samplingDepth: "",
        //   bioGroup: [""]
        // };

        // va
        this.htmls$ = from([this.htmlObj]);
    }

    ngOnInit() {
        this.dialogService.activeComponent().subscribe((activeComponent) => {
            if (!activeComponent) {
                this.closeDialog();
            }
            this.htmlObj.entity.activeComponent = DownloadComponent;
        });

        this.globeService.getPointInfo().subscribe((message) => {
            if (this.htmlObj) {
                this.htmlObj.entity.id = message.id;
                this.htmlObj.entity.show = message.show;
                this.htmlObj.entity.position = message.position;

                if (message.data) {
                    this.htmlObj.entity.data = message.data;

                    this.filterOptions.filterValues = message.filterValues;
                    this.filterOptions.sampleId = message.id;
                    // this.filterOptions.GeoSpatialString =
                    //   message.data.filterOptions.GeoSpatialString;
                }

                this.layer.update(this.htmlObj.entity, this.htmlObj.id);
            }

            // this.layer.removeAll();
            // this.showPopup = false;

            // this.showPopup = message.show;
            // this.layer.refreshAll([{
            //   id: '0',
            //   actionType: ActionType.ADD_UPDATE,
            //   entity: {
            //     id: message.id,
            //     show: message.show,
            //     name: 'Placeholder',
            //     position: message.position,
            //     color: Cesium.Color.RED
            //   },
            // }]);
        });
    }

    closePopup() {
        if (this.htmlObj) {
            this.htmlObj.entity.id = '0';
            this.htmlObj.entity.show = false;
            this.htmlObj.entity.position = Cesium.Cartesian3.fromDegrees(
                30,
                30
            );
            this.layer.update(this.htmlObj.entity, this.htmlObj.id);
        }
    }

    getMinMaxLatlong(data, type) {
        let arr = [];
        if (data[0] == '') {
            data.shift();
        }

        let lat = [];
        let long = [];
        let minLat = 0;
        let maxLat = 0;
        let minLong = 0;
        let maxLong = 0;

        data.forEach((item) => {
            var coor = item.split('/');
            lat.push(parseFloat(coor[0]));
            long.push(parseFloat(coor[1]));
        });

        if (type == 'lat') {
            if (Math.min(...lat) == Math.max(...lat)) {
                return Math.min(...lat);
            } else {
                return Math.min(...lat) + ' - ' + Math.max(...lat);
            }
        } else {
            if (Math.min(...long) == Math.max(...long)) {
                return Math.min(...long);
            } else {
                return Math.min(...long) + ' - ' + Math.max(...long);
            }
        }
    }

    addSpace(data) {
        if (data) {
            return data.join(', ');
        } else {
            return data;
        }
    }

    fixData(data, delimiter) {
        if (!data) {
            return '';
        }
        let arr = data.split(delimiter);
        let result = '';
        if (arr && arr.length == 2) {
            if (arr[0] == arr[1]) {
                result = arr[0];
            } else {
                result = arr[0] + ' to ' + arr[1];
            }
        }
        return result;
    }

    openDialog() {
        this.downloadService.setFilterValue(this.filterOptions);
        this.htmlObj.entity.data.showDialog = true;
        this.layer.update(this.htmlObj.entity, this.htmlObj.id);
        //this.dialogService.displayComponent(DownloadComponent);
    }

    closeDialog() {
        this.htmlObj.entity.data.showDialog = false;
        if (this.layer) {
            this.layer.update(this.htmlObj.entity, this.htmlObj.id);
        }
    }
}
